// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.code-input[data-v-58dcadfc] {\r\n  display: flex;\r\n  gap: 10px;\n}\n.code-box[data-v-58dcadfc] {\r\n  width: 28px;\r\n  height: 28px;\r\n  text-align: center;\r\n  font-size: 20px;\r\n  /*border: 1px solid #ccc;*/\r\n  border: 1px solid #D51315;\r\n  border-radius: 6px;\n}\n.code-box[data-v-58dcadfc]:focus {\r\n  outline: 2px solid #DE2726;\r\n  border: 1px solid #fff;\n}\r\n", ""]);
// Exports
module.exports = exports;
